export default {
  APPROVED: 'approved',
  PROPOSED: 'proposed',
  TERMINATED: 'terminated',
};
